import React, { useState } from "react";
import { Admin, Resource } from "react-admin";

import Dashboard from "./components/Dashboard";
import Layout from "./components/Layout";
import controllers from "./components/Controllers";
import organizations from "./components/Organizations";
import users from "./components/Users";
import admins from "./components/Admins";

import LoginView from "./pages/LoginView";

import { AuthContext } from "./contexts/auth";

import { AuthState, defaultAuthState } from "./store/models/auth";

import { dataProvider } from "./dataProvider";
import authProvider from "./auth/auth-provider";

import "./App.css";

const App = () => {
  const [authState, setAuthState] = useState<AuthState>(defaultAuthState);

  return (
    <AuthContext.Provider value={{ authState, setAuthState }}>
      <Admin
        dataProvider={dataProvider}
        authProvider={authProvider}
        loginPage={LoginView}
        dashboard={Dashboard}
        layout={Layout}
      >
        <Resource name="admins" {...admins} />
        <Resource name="users" {...users} />
        <Resource name="organizations" {...organizations} />
        <Resource name="controllers" {...controllers} />
      </Admin>
    </AuthContext.Provider>
  );
};

export default App;
